import { UIHeading2, UIHeading5 } from '@cian/ui-kit';
import { type FC } from 'react';

import { AdLabel } from 'shared/components/AdLabel';
import type { TAdSidebarMapTemplateContext } from 'shared/types/bannerContext';
import { Ticker } from 'shared/components/Ticker';
import { toCssImageUrl } from 'shared/utils/toCssImageUrl';

import styles from './SidebarMapListing.css';

type TSidebarMapListingTemplateProps = {
  context: TAdSidebarMapTemplateContext;
};

export const SidebarMapListing: FC<TSidebarMapListingTemplateProps> = ({ context }) => {
  const { url, image, logoImageUrl, label, title, description, annotation } = context;

  return (
    <a className={styles['container']} href={url} target="_blank" rel="noopener noreferrer">
      <div className={styles['image-container']}>
        {image && <div className={styles['image']} style={{ backgroundImage: toCssImageUrl(image) }} />}
      </div>

      <div className={styles['content-container']}>
        <div className={styles['top']}>
          {logoImageUrl && (
            <div className={styles['logo-container']}>
              <img src={logoImageUrl} className={styles['logo']} alt="" />
            </div>
          )}
          {!!label && (
            <div>
              <AdLabel label={label} />
            </div>
          )}
        </div>

        <div className={styles['content']}>
          <UIHeading2 color="text-on-bright-default">{title}</UIHeading2>
          {description && <UIHeading5 color="text-on-bright-default">{description}</UIHeading5>}
        </div>
      </div>
      {annotation && (
        <div className={styles['annotation']}>
          <Ticker theme="dark-background" text={annotation} />
        </div>
      )}
    </a>
  );
};
